<template>
    <v-app>
        <v-dialog v-model="dialog" max-width="800">
            <v-card>

              <v-toolbar dark>
                <v-card-title class="headline">
                  {{`${edit?'Update':"Add"} lesson plan`}}
                  <hr>
                </v-card-title>

                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-btn icon  @click="resetForm">
                    <i class="fas fa-times"></i>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>

                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Title" v-model="lesson_plan.title" outlined dense>

                            </v-text-field>
                            <span class="text-danger" v-if="$v.lesson_plan.title.$error">This information is required</span>

                        </v-col>
                        <div class="col-12">
                            Description <span class="text-danger"></span>
                            <ckeditor v-model="lesson_plan.description" :config="editorConfig"></ckeditor>
                            <span class="text-danger"
                                  v-if="$v.lesson_plan.description.$error">This information is required</span>
                        </div>
                        <v-col cols="6">
                            <v-select
                                    :items="academic_years"
                                    v-model="lesson_plan.academic_year_id"
                                    label="Batch"
                                    item-text="title"
                                    item-value="id"
                                    outlined
                                    dense
                            >

                            </v-select>

                            <span class="text-danger" v-if="$v.lesson_plan.academic_year_id.$error">This information is required</span>
                        </v-col>

                        <v-col cols="6">
                            <v-select
                                    :items="programs"
                                    v-model="lesson_plan.program_id"
                                    outlined
                                    dense
                                    label="Program"
                                    item-text="title"
                                    item-value="id"
                                    @change="getGrades"
                            >

                            </v-select>
                            <span class="text-danger" v-if="$v.lesson_plan.program_id.$error">This information is required</span>

                        </v-col>
                        <v-col cols="6">
                            <v-select
                                    :items="gradesLevels"
                                    v-model="lesson_plan.grade_id"
                                    outlined
                                    dense
                                    label="Grade/semester"
                                    item-text="title"
                                    item-value="id"
                                    @change="getSearchedCourses"
                            >

                            </v-select>
                        </v-col>
                        <v-col cols="6">
                            <v-select
                                    :items="courses"
                                    v-model="lesson_plan.course_id"
                                    @change="getClass"
                                    outlined
                                    dense
                                    label="Course"
                                    item-text="title"
                                    item-value="id"
                            >

                            </v-select>
                            <span class="text-danger" v-if="$v.lesson_plan.course_id.$error">This information is required</span>

                        </v-col>
                        <v-col cols="6">
                            <v-select
                                    :items="academic_classes"
                                    v-model="lesson_plan.class_id"
                                    outlined
                                    dense
                                    label="Class"
                                    item-text="title"
                                    item-value="id"
                                    clearable
                            >

                            </v-select>
                        </v-col>
<!--                        <v-col cols="6">-->
<!--                            <v-select-->
<!--                                    :items="topics"-->
<!--                                    v-model="lesson_plan.topic_id"-->
<!--                                    outlined-->
<!--                                    dense-->
<!--                                    label="Topic"-->
<!--                                    item-text="title"-->
<!--                                    item-value="id"-->
<!--                            >-->
<!--                            </v-select>-->

<!--                        </v-col>-->


                        <div class="col-3">
                            <v-switch
                                    v-model="lesson_plan.is_active"
                                    label="Status"
                            >
                            </v-switch>
                        </div>
                        <v-col cols="12">
                            <div class="text-right float-right">
                                <v-btn depressed @click="resetForm" class="text-gray btn btn-standard cancel-btn">
                                    Cancel
                                </v-btn>
                                <v-btn depressed :loading="isBusy" @click="createOrUpdate"
                                       class="text-white ml-2 btn btn-primary ">
                                    Save
                                </v-btn>
                            </div>

                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>
        </v-dialog>
    </v-app>

</template>
<script>
    import {required} from "vuelidate/lib/validators";
    import LessonPlannerService from "@/core/services/lesson-planner/lesson-planner/LessonPlannerService";
    import {LessonPlannerMixin} from "@/mixins/LessonPlannerMixin";
    import CoursesService from "@/core/services/courses/CoursesService";

    const courseService = new CoursesService();
    const lessonPlannerService = new LessonPlannerService();

    export default {
        name: 'lesson_plan',
        mixins: [LessonPlannerMixin],
        validations: {
            lesson_plan: {
                title: {required},
                description: {required},
                academic_year_id: {required},
                program_id: {required},
                course_id: {required},

            }
        },
        data() {
            return {
                editorConfig: {
                  versionCheck: false,
                    toolbar: [
                        [
                            "Bold",
                            "Italic",
                            "Underline",
                            "Strike",
                            "RemoveFormat",
                            "Link",
                            "NumberedList",
                            "BulletedList",
                        ],
                    ],
                },
                dialog: false,
                edit: false,
                sizeExceed: false,
                isBusy: false,
                search: {
                    active: "active",
                    is_parent: 1,
                },
                lesson_plan: {
                    title: null,
                    is_active: true
                },
                courseSearch: {
                    program_id: "",
                    grade_id: "",
                    title: "",
                    subject_code: "",
                },
            };
        },
        computed: {},
        mounted() {
            this.getPrograms();
            this.getAcademicYears();

        },
        methods: {
            getSearchedCourses() {
                this.getClass();
                this.courseSearch.grade_id = this.lesson_plan.grade_id;
                this.courseSearch.program_id = this.lesson_plan.program_id;
                this.isBusy = true;
                this.$bus.emit('toggleLoader',);
                courseService.paginate(this.courseSearch,this.page).then(response => {
                    this.courses = response.data.data;
                    this.isBusy = false;
                    this.$bus.emit('toggleLoader');
                });
            },
            showModal(id = null) {
                this.__reset();
                if (id) {
                    this.edit = true
                    this.__get(id)
                    this.getAllCourses();
                    this.getAllGrades();
                    this.getAllClasses();
                } else
                    this.edit = false;
                this.dialog = true;
            },
            __reset() {
                this.lesson_plan = {
                    title: null,
                    is_active: true
                }
            },
            hideModal() {
                this.dialog = false;
            },
            __get(id) {
                lessonPlannerService.show(id).then(response => {
                    this.lesson_plan = response.data.lesson;
                    this.lesson_plan.program_id = this.lesson_plan.course.program_id;
                    this.getGrades();
                    this.lesson_plan.grade_id = this.lesson_plan.course.grade_id;
                })
            },

            createOrUpdate() {
                if (this.syllabus) {
                    this.lesson_plan.course_id = this.syllabus.course_id;
                }
                this.$v.lesson_plan.$touch();
                if (this.$v.lesson_plan.$error) {
                    setTimeout(() => {
                        this.$v.lesson_plan.$reset();
                    }, 3000);
                } else {
                    let fd = this.lesson_plan;
                    if (this.edit) {
                        this.__update(fd);
                    } else {
                        this.__create(fd);
                    }
                }
            },
            __update(fd) {
                this.isBusy = true;
                lessonPlannerService
                    .update(this.lesson_plan.id, fd)
                    .then(response => {
                        this.isBusy = false;
                        this.$snotify.success("Information updated");

                        this.resetForm();
                    })
                    .catch(error => {
                        this.isBusy = false;
                        this.$snotify.error("Something Went Wrong");
                        // console.log(error);
                    });
            },

            __create(fd) {
                this.isBusy = true;
                lessonPlannerService
                    .store(fd)
                    .then((response) => {
                        this.isBusy = false;
                        this.resetForm();
                        this.$router.push({ name:'course-summary',params:{
                                lesson_plan_id:response.data.lesson_plan.id
                            }});
                        this.$snotify.success("Information added");

                    })
                    .catch(error => {
                        this.isBusy = false;
                        this.$snotify.error("Something Went Wrong");
                        console.log(error);
                    });
            },
            resetForm() {
                this.$v.lesson_plan.$reset();
                this.edit = false;
                this.lesson_plan = {
                    title: null,
                    is_active: null
                };
                this.hideModal();
                this.$emit("refresh_lesson_plan");
            }
        }
    };
</script>
